import { onlyRoleMapping, userHasLevel } from "../../../engine/AuthRoute";
import {
  diplomas,
  languagesList,
  levels,
  modeInterpretariat,
  renderUserName,
  renderUserNameEmail,
  roles,
  statusPrestations,
  statusPrestationsActual,
  statusPrestationsValues,
  subRoles,
  subRolesCheckbox,
  typeIntervention,
} from "../../../utils/constants";
import { AiFillCalendar } from "react-icons/ai";
import { EditFilled, PhoneOutlined, UserOutlined } from "@ant-design/icons";
import { HiOutlineMail } from "react-icons/hi";
import React, { useContext, useEffect, useState } from "react";
import Dayjs from "dayjs";
import dayjs, { tz } from "../../../utils/dayjs";
import { BiLinkExternal } from "react-icons/bi";
import { typesPrestation } from "../../../utils/typesPrestation";
import { Alert, Button, Form, Space } from "antd";
import { IoAddSharp } from "react-icons/io5";
import { CreateApplicant } from "../../../shared/components/CreateApplicant/CreateApplicant";
import routes from "../../../engine/routes";
import { modalsByContext } from "../../../shared/components/Modals/modals";
import {
  renderAdress,
  typeAddress,
} from "../../../shared/container/Addresses/AddresseItem/AddresseHelpers";
import { ModalContext } from "../../../engine/context/Modal.provider";
import { LuMapPin } from "react-icons/lu";
import { usePrestationDisabler } from "../../../engine/hooks/usePrestationDisabler";
import { isArray } from "lodash";
import { DurationHourChecker } from "./DurationHourChecker";
import {
  disabledDateNext12Months,
  disabledDatePast,
  assertInstitutionStartNotUrgent,
  validateTimeBetween,
} from "../../../shared/components/CustomForm/form.helpers";
import { useSelector } from "react-redux";
import {tooltipLangue} from "../PrestationSelector/langue.tooltip";

export const prestationInputs = (
  prestation,
  formRef,
  change,
  setChange,
  user,
  dataForm,
  setDataForm,
  loading,
) => {
  const [institutionReady, setInstitutionReady] = useState(false);
  const {
    intervention: { startDate, endDate, location, extra },
    comment,
    applicationAt = null,
    category,
    institution,
    applicant,
    isSequentialPrestation,
  } = prestation;

  // hidden: dataForm.institution === undefined,

  const context = useContext(ModalContext);

  let isDraft = prestation.status === statusPrestationsValues.draft;
  const scheduleLockReferenceDate =
    prestation?.interventionFinal?.startDate ||
    prestation?.finalStartDate ||
    startDate;
  const isInstitutionScheduleLocked =
    user?.role === roles.institution &&
    prestation?._id !== undefined &&
    !!scheduleLockReferenceDate &&
    !dayjs().isBefore(dayjs(scheduleLockReferenceDate).subtract(24, "hour"));

  useEffect(() => {
    if (prestation.category && formRef.current && institutionReady) {
      formRef.current.setFieldsValue({
        category: prestation.category,
      });
    }
  }, [institutionReady]);

  const setAdressByList = () => {
    let selected = formRef.current.getFieldValue("intervention.locationTo");

    const addresses = formRef.current["_intervention.locationTo"];

    let findAddress = addresses.find(e => e._id === selected);

    formRef.current.setFieldsValue({
      "intervention.location": findAddress.maps,
      "intervention.locationName": findAddress.location,
    });
  };

  const disabledPast = current => {
    // Rule 1: Not in past
    return current && current < dayjs().startOf("day");
  };

  const isInstitutionUser = user?.role === roles.institution;

  const disabledDates = current => {
    if (onlyRoleMapping([roles.institution])) {
      return disabledDatePast(current) || disabledDateNext12Months(current);
    } else {
      return false;
    }
  };

  const dynamicSelectContent = () => {
    return typesPrestation.filter(item => {
      if (
        formRef.current === null ||
        formRef.current?._institution === undefined ||
        formRef.current?._institution?.length === 0
      ) {
        return false;
      } else {
        let institutionId = formRef.current.getFieldValue("institution");
        let institution = formRef.current._institution.find(
          e => e._id === institutionId,
        );
        if (institution?.mainType && institution?.mainType !== "") {
          return institution?.mainType === item.label;
        } else {
          return true;
        }
      }
    });
  };

  return [
    {
      parentLabel: "",
      children: [
        {
          label: "N° de commande",
          placeholder: "Sera généré automatiquement",
          name: "reference",
          disabled: true,
          capitalize: false,
          type: "input",
          variant: "important",
          col: 24,
        },
        {
          label: "Institution du demandeur",
          disabled:
            !isDraft ||
            !userHasLevel({
              not: {
                [roles.institution]: "", //
              },
            }),
          name: "institution",
          value: userHasLevel({
            not: {
              [roles.institution]: "", //
            },
          })
            ? institution?._id
            : user.institution._id,
          type: "dynamic-select",
          required: true,
          endPoint: "institutions",
          itemsCallBack: (institutions, form) => {
            setInstitutionReady(true);
          },
          itemCallback: item => {
            return {
              key: item._id,
              label: `${item.name}`,
              value: item._id,
            };
          },
          col: 24,
        },
        {
          // value: type,
          label: "Catégorie",
          name: "category",
          showSearch: true,
          hidden: dataForm.institution === undefined,
          value: category,
          defaultValue: category,
          required: true,
          watchRenderCondition: true,
          multiple: true,
          type: "select",
          // selectContent: [],
          selectContent: institutionReady ? dynamicSelectContent() : [],
          selectType: "group",
          col: 24,
          watchDynamicObject: "institution",
          // filterContent: (item, institution) => {
          //   if (institution?.mainType && institution?.mainType !== "") {
          //     return true;
          //   } else {
          //     return true;
          //   }
          // },
        },
        {
          label: "Status",
          hidden: dataForm.institution === undefined,
          name: "status",
          disabled: true,
          type: "select",
          selectContent: statusPrestationsActual,
          col: 24,
        },
        {
          required: true,
          showSearch: true,
          hidden: dataForm.institution === undefined,
          disabled: !isDraft,
          label: "Langue de la prestation",
          name: "language",
          quote: tooltipLangue,
          quoteIconText: 'Aide langues',
          quoteStyle:'large',
          value: prestation.language,
          type: "dynamic-select",
          endPoint: "users/languages",
          col: 24,
          // onChange: value => {
          //   setLanguageSearch(value);
          // },
          itemCallback: item => {
            return {
              key: item.value,
              label: `${
                languagesList.find(e => e.value === item.value)?.label
              }`,
              value: item.value,
            };
          },
        },
        {
          label: "Date de dépôt de la demande",
          quote: "Automatique lors de la confirmation de la commande",
          name: "applicationAt",
          hidden: dataForm.institution === undefined,
          visible: userHasLevel({
            only: {
              [roles.permanance]: "crud", //
              [roles.admin]: "crud", //
            },
          }),
          value: applicationAt === null ? undefined : dayjs(applicationAt),
          suffixIcon: <AiFillCalendar />,
          showTime: true,
          showClear: true,
          type: "date-time",
          large: 24,
        },
        {
          type: "component",
          col: 24,
          hidden: !isInstitutionScheduleLocked,
          component: () => (
            <Alert
              type="warning"
              showIcon
              message="Modification de l'horaire indisponible"
              description="La modification de l'horaire n'est plus disponible dans les 24 heures precedant la prestation. Merci de contacter la permanence pour toute demande."
            />
          ),
        },
        {
          hidden: dataForm.institution === undefined,
          required: true,
          label: "Date et heure de début",
          name: "intervention.startDate",
          rules: [
            refValidator => ({
              validator(_) {
                return validateTimeBetween(
                  refValidator,
                  "intervention.startDate",
                  "intervention.endDate",
                  user,
                  false,
                  false,
                ).then(() =>
                  assertInstitutionStartNotUrgent(
                    refValidator.getFieldsValue(true)["intervention.startDate"],
                    user,
                  ),
                );
              },
            }),
          ],
          value: dayjs(startDate),
          disabled: isInstitutionScheduleLocked,
          suffixIcon: <AiFillCalendar />,
          onChange: props => {
            let val;

            if (props.format !== undefined) {
              val = props.format();
            }

            if (props.value !== undefined) {
              val = props.value.format();
            }

            setDataForm({
              ...dataForm,
              "intervention.startDate": val,
            });
          },
          showTime: true,
          watch: "intervention.endDate",
          watchRenderCondition: false,
          disabledDate: disabledDates,
          showNow: !isInstitutionUser,
          watchValuesCallback: (start, end, ref) => {
            try {
              if (!end || !start) return;

              // Check the difference in minutes
              const differenceInMinutes = end.diff(start, "minute");

              // If start is after or exactly at the same time as end
              if (differenceInMinutes <= 0) {
                // let newStartD = end.subtract(1, "hour");
                // ref.current.setFieldsValue({
                //   "intervention.startDate": newStartD,
                // });
                // setDataForm({
                //   ...dataForm,
                //   "intervention.startDate": newStartD.format(),
                // });
              }
            } catch (e) {
              console.log(e);
            }
          },
          type: "date-time",
          md: 12,
          lg: 12,
          large: 12,
          xs: 24,
        },
        {
          required: true,
          hidden: dataForm.institution === undefined,
          label: "Date et heure de fin",
          rules: [
            refValidator => ({
              validator(_) {
                return validateTimeBetween(
                  refValidator,
                  "intervention.startDate",
                  "intervention.endDate",
                  user,
                  false,
                  false,
                ).then(() =>
                  assertInstitutionStartNotUrgent(
                    refValidator.getFieldsValue(true)["intervention.startDate"],
                    user,
                  ),
                );
              },
            }),
          ],
          name: "intervention.endDate",
          value: dayjs(endDate),
          disabled: isInstitutionScheduleLocked,
          suffixIcon: <AiFillCalendar />,
          onChange: props => {
            let val;

            if (props.format !== undefined) {
              val = props.format();
            }

            if (props.value !== undefined) {
              val = props.value.format();
            }
            setDataForm({
              ...dataForm,
              "intervention.endDate": val,
            });
          },
          watch: "intervention.startDate",
          disabledDate: disabledDates,
          showNow: !isInstitutionUser,
          watchRenderCondition: false,
          watchValuesCallback: (end, start, ref) => {
            try {
              if (!end || !start) return;

              // Check the difference in minutes
              const differenceInMinutes = start.diff(end, "minute");

              // If end is before or exactly  at the same time as start
              if (differenceInMinutes >= 0) {
                let newEndD = start.add(1, "hour");
                ref.current.setFieldsValue({
                  "intervention.endDate": newEndD,
                });
                setDataForm({
                  ...dataForm,
                  "intervention.endDate": newEndD.format(),
                });
              }
            } catch (e) {
              console.log(e);
            }
          },
          showTime: true,
          type: "date-time",
          md: 12,
          large: 12,
          lg: 12,
          xs: 24,
        },
        {
          col: 24,
          type: "component",
          hidden: dataForm.institution === undefined,
          name: "durationHour",
          noWrapper: true,
          component: ({ refForm }) => (
            <DurationHourChecker
              keys={["intervention.startDate", "intervention.endDate"]}
            />
          ),
        },
      ],
    },
    typeInterventionInputs({
      hidden: dataForm.institution === undefined,
      type: dataForm?.intervention?.type,
    }),
    {
      parentLabel: "Lieu de l'intervention",
      hidden: dataForm.institution === undefined,
      children: [
        {
          type: "component",
          watchDynamicObject: "institution",
          watchRenderCondition: true,
          component: ({ disabled }) => {
            return (
              <Space direction={"horizontal"}>
                <Button
                  disabled={disabled}
                  type={"primary"}
                  onClick={() => {
                    let instituionId = formRef.current.getFieldValue(
                      "institution",
                    );
                    context.openModal(
                      modalsByContext.InstitutionSelectAddress,
                      {
                        institution: instituionId,
                        formRef,
                      },
                      ({ _id, data }) => {
                        if (data) {
                          formRef.current.setFieldsValue({
                            "intervention.location": data.maps,
                            "intervention.locationName": data.location,
                          });
                          setChange(_id);
                        }
                      },
                    );
                  }}
                  icon={
                    <LuMapPin
                      style={{
                        marginTop: "0px",
                      }}
                      size={15}
                    />
                  }
                  size={"small"}
                >
                  Sélectionner un lieu d'intervention prédéfini
                </Button>
              </Space>
            );
          },
          col: 24,
        },
        {
          label: "Lieu de l'intervention (Institution)",
          name: "intervention.locationName",
          disabled: true,
          // required: true,
          type: "input",
          watchRequiredCondition: true,
          // watchDynamicObject: "institution",
          // watchRenderCondition: true,
          watch: "intervention.type",
          watchValues: [typeIntervention.in_person],
          col: 24,
        },
        {
          // required: true,
          label: "Adresse d'intervention",
          disabled: true,
          name: "intervention.location",
          // watchDynamicObject: "institution",
          // watchRenderCondition: true,
          watch: "intervention.type",
          watchValues: [typeIntervention.in_person],
          watchRequiredCondition: true,
          watchValuesCallback: (value, form, r) => {},
          value: prestation.intervention.location,
          type: "google-adress",
          col: 24,
          // watchDynamicObject: "institution",
          // watchDynamicSetEmpty: true,
          // watchRenderCondition: true,
          // watchDynamicSetter: institution => institution?.interventionLocation,
        },
        {
          visible:
            userHasLevel({
              only: {
                [roles.admin]: "crud", //
              },
            }) && [statusPrestationsValues.planned].includes(prestation.status),
          label: "Lieu de départ de l'interprète",
          name: "intervention.locationFrom",
          value: prestation.intervention.locationFrom,
          type: "google-adress",
          col: 24,
        },
        {
          label:
            "Complément du lieu de l'intervention (Étage, Salle, Digicode)",
          name: "intervention.extra",
          type: "input",
          // watchDynamicObject: "institution",
          // watchRenderCondition: true,
          watch: "intervention.type",
          watchValues: [
            typeIntervention.visio,
            typeIntervention.in_person,
            typeIntervention.phone,
          ],
          col: 24,
        },
        {
          label: "Ceci est une prestation courte",
          description: (
            <span>
              Cette prestation pourra être facturée moins d’une heure, mais au
              minimum : 1) la durée commandée et 2) la durée effective.
              <br />
              <br />
              Cette prestation doit faire partie d’une suite de prestations
              d’une durée totale d’au moins 1 heure (yc précédentes et
              suivantes) et effectuée par le même interprète. Si ce n’est pas le
              cas, faites en sorte que la durée totale fasse au moins 1 heure.
              Remarque : Si plus de 60 min d’attente sont planifiées entre deux
              prestations, veuillez ne pas les considérer comme une suite.
            </span>
          ),
          name: "isSequentialPrestation",
          visible: userHasLevel({
            only: {
              [roles.admin]: "r", //
              [roles.permanance]: "r", //
            },
          }),
          type: "checkbox-bool",
          value: isSequentialPrestation,
          col: 24,
        },
      ],
    },
    {
      parentLabel: "Critères de l'interprète ",
      hidden:
        dataForm.institution === undefined ||
        !onlyRoleMapping([roles.admin, roles.permanance]),
      children: [
        {
          required: true,
          label: "Genre de l'interprète",
          name: "search.searchGenre",
          type: "select",
          multiple: true,
          selectContent: [
            { label: "Femme", value: "female" },
            { label: "Homme", value: "male" },
          ],
          col: 24,
        },
        {
          required: true,
          label: "Niveau de l'interprète",
          name: "search.searchLevel",
          type: "select",
          multiple: true,
          selectContent: levels,
          col: 24,
        },
      ],
    },
    {
      parentLabel: "Informations demandeur",
      hidden: dataForm.institution === undefined,
      children: [
        {
          label: "Demandeur",
          //  disabled: !isDraft,
          name: "applicant",
          required: true,
          value: applicant?._id,
          type: "dynamic-select",
          endPoint: institution => {
            const institutionId =
              typeof institution === "object" && institution !== null
                ? institution._id
                : institution;

            if (prestation._id === undefined) {
              return `/users?subRole=${subRoles.institutionDemander}&institution=${institutionId}&status=active,inactive`;
            } else {
              return `/users?subRole=${subRoles.institutionDemander}&institution=${institutionId}`;
            }
          },
          watchDynamicObject: "institution",
          watchRenderCondition: true,
          watchDynamicSetEmpty: true,
          updateEndPoint: [change],
          itemsCallBack: (users, form) => {},
          filterItem: item => {
            if (
              user.subRoles.includes(subRoles.institutionDemander) &&
              !user.subRoles.includes(subRoles.institutionAdmin)
            ) {
              return item._id === user._id;
            } else {
              return true;
            }
          },
          itemCallback: item => {
            return {
              key: item._id,
              label: renderUserNameEmail(item),
              value: item._id,
              disabled: item.status === "archived",
            };
          },
          col: 24,
        },
        {
          type: "component",
          watchDynamicObject: "institution",
          watchRenderCondition: true,
          component: ({ disabled }) => {
            return (
              <>
                {userHasLevel({
                  only: {
                    [roles.admin]: "r", //
                    [roles.permanance]: "r", //
                    [subRoles.institutionAdmin]: "r", //
                  },
                }) && (
                  <CreateApplicant
                    disabled={disabled}
                    key={Math.random()}
                    name={"applicant"}
                    formRef={formRef}
                    onCreated={_id => {
                      setChange(_id);
                    }}
                  />
                )}
              </>
            );
          },
          col: 24,
        },
      ],
    },
    {
      children: [
        {
          label: "Sauvegarder & suivant",
          name: "send",
          loading: loading,
          hidden: dataForm.institution === undefined,
          value: "send",
          type: "submit",
          col: 24,
          align: "right",
        },
      ],
    },
  ];
};

export const typeInterventionInputs = props => {
  const { prestation } = useSelector(state => state.prestation);

  let interpreteRef = props?.interpreteRef || null;
  let hidden = props?.hidden || false;

  let interpretingMode = interpreteRef?.interpreteData?.interpretingMode;

  let modeInterpretariatFinal = modeInterpretariat;

  if (isArray(interpretingMode)) {
    modeInterpretariatFinal = modeInterpretariat.map(p => {
      if (interpretingMode.includes(p.value)) {
        return p;
      } else {
        return { ...p, disabled: true };
      }
    });
  }

  return {
    parentLabel: null,
    children: [
      {
        label: "Type d'intervention",
        componentLabel: (
          <span>
            Type d'intervention{" "}
            <a
              href="https://www.oseo-vs.ch/wp-content/uploads/2024/09/conditions_tarifaires_AVIC_08_2024.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Conditions tarifaires
            </a>
          </span>
        ),
        name: "intervention.type",
        required: true,
        value: prestation?.intervention?.type || null,
        type: "radios",
        radios: modeInterpretariatFinal,
        col: 24,
        hidden,
      },
      // {
      //   label: "Numéro de téléphone pour l'intervention",
      //   name: "intervention.phone",
      //   type: "input",
      //   required: true,
      //   watch: "intervention.type",
      //   addonBefore: "+41",
      //   watchRenderCondition: true,
      //   watchValues: [typeIntervention.phone],
      //   col: 24,
      //   hidden,
      // },
      {
        label: "Lien pour la visio-conférence",
        name: "intervention.linkVisio",
        type: "input",
        required: true,
        watch: "intervention.type",
        addonBefore: <BiLinkExternal />,
        watchRenderCondition: true,
        watchValues: [typeIntervention.visio],
        col: 24,
        hidden,
      },
    ],
  };
};
